import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Sentry } from "../sentryInstrumentReact";
import ProductCard from './ProductCard';



function ProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSaleProducts, setShowSaleProducts] = useState(false);
  const [salePriceItemPresent, setSalePriceItemPresent] = useState(false);
  const [typesCheckboxes, setTypesCheckboxes] = useState({
    bk: true,
    dl: true,
  });
  const csrftoken = Cookies.get('csrftoken');
  const currentURL = window.location.href;

  function extractKeyValueFromURL(url) {
    const URLParts = url.split('/');
    let result = {};
    if (URLParts[4] === "authors" && URLParts[5]) {
      result['author'] = URLParts[5]; 
    } else if (URLParts[4] === "collections" && URLParts[5]) {
      result['collection'] = URLParts[5]; 
    } else if (URLParts[4] === "topics" && URLParts[5]) {
      result['topic'] = URLParts[5]; 
    }
    return result;
  }
  
  


  // initial loading of products
  useEffect(() => {
    const keyValueObj = extractKeyValueFromURL(currentURL);
    const searchParams = new URLSearchParams(keyValueObj);
    const fetchUrl = `/store/_api/products/?${searchParams}`;
    
    async function fetchProducts() {
      try {
        const response = await fetch(fetchUrl, {
          method: 'GET',
          headers: {"Content-Type": "application/json", "X-CSRFToken": csrftoken},
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log(data);
        setProducts(data.results);
        for (let item of data.results) {
          if (item.sale_price !== null) {
            setSalePriceItemPresent(true);
            break;
          }
        }

      } catch (error) {
        console.log(error);
		if (Sentry && Sentry.getClient()) {
          Sentry.captureException(error);
		}
      }
      setLoading(false);
    }
    fetchProducts();
  }, []);


  function sortProducts(sortBy, sortDirection) {
    
    if (sortBy === "title" && sortDirection === "asc") {
      const productsAscending = [...products].sort((a, b) =>
        a.title > b.title ? 1 : -1,
      );
      setProducts(productsAscending);
    } else if (sortBy === "title" && sortDirection === "desc") {
      const productsAscending = [...products].sort((a, b) =>
        a.title < b.title ? 1 : -1,
      );
      setProducts(productsAscending);
    } else if (sortBy === "price" && sortDirection === "asc") {
      const productsAscending = [...products].sort((a, b) =>
        parseFloat(a.price) > parseFloat(b.price) ? 1 : -1,
      );
      setProducts(productsAscending);
    } else if (sortBy === "price" && sortDirection === "desc") {
      const productsAscending = [...products].sort((a, b) =>
        parseFloat(a.price) < parseFloat(b.price) ? 1 : -1,
      );
      setProducts(productsAscending);
    }

  }


  function toggleSaleItems() {
    setShowSaleProducts(!showSaleProducts);
  }

  function handleClick(e) {
    const { name } = e.target;
    console.log(name);
    setTypesCheckboxes(prev => ({
      ...prev,
      [name]: !prev[name],
    }));

  }

  const displayedProducts = showSaleProducts 
    ? products.filter(product => product.sale_price !== null)
    : products;

  if (loading) {
    return (
      <p>{window.gettext("Loading...")}</p>
    );
  }

  return (
    <>
      <nav className='sorting-options'>
        <button className='btn btn-sm' onClick={() => {sortProducts("title", "asc")}}><svg className="icon" width={14} height={14}><use xlinkHref="#sort" /></svg> A to Z</button>
        <button className='btn btn-sm' onClick={() => {sortProducts("title", "desc")}}><svg className="icon" width={14} height={14}><use xlinkHref="#sort" /></svg> Z to A</button>
        <button className='btn btn-sm' onClick={() => {sortProducts("price", "asc")}}><svg className="icon" width={14} height={14}><use xlinkHref="#sort" /></svg> $ to $$$</button>
        <button className='btn btn-sm' onClick={() => {sortProducts("price", "desc")}}><svg className="icon" width={14} height={14}><use xlinkHref="#sort" /></svg> $$$ to $</button>
        
        {salePriceItemPresent && 
          <button className='btn btn-sm' onClick={toggleSaleItems}>
            {showSaleProducts ? "Show All Resources" : "Show Sale Resources Only"}
          </button>
        }
      </nav>
      <div className="container">
        <ul className="small-product-list list-unstyled">
          {displayedProducts.map((product) => (
            <ProductCard 
              title={product.title}
              slug={product.slug}
              price={product.price}
              thumbnail={product.thumbnail}
              webpThumbnail={product.webpThumbnail}
              salePrice={product.sale_price}
            />
            ))}
        </ul>
      </div>
    </>
  );
}

export default ProductList;
